define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FAssetConditionDomain = void 0;
    class FAssetConditionDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FAssetConditionDomain.GoodWorkingAsRequired, value: "Good - Working as required" },
                    { key: FAssetConditionDomain.FairWorkingInDiminishedCapacity, value: "Fair - Working in diminished capacity" },
                    { key: FAssetConditionDomain.PoorWorkingInSomeCapacityLimitedLifeLeft, value: "Poor - Working in some capacity - limited life left" },
                    { key: FAssetConditionDomain.BrokenDownCanBeRepairedOrWouldWorkIfOtherAssetsWereRepairedOrReplaced, value: "Broken Down - Can be repaired or would work if other assets were repaired or replaced" },
                    { key: FAssetConditionDomain.NotServiceableCannotBeRepairedNotEconomicalToRepair, value: "Not Serviceable - Cannot be repaired / not economical to repair" },
                    { key: FAssetConditionDomain.UsedForSpares, value: "Used for spares" },
                    { key: FAssetConditionDomain.DestroyedDumpedDecommissioned, value: "Destroyed / dumped / decommissioned" },
                    { key: FAssetConditionDomain.Stolen, value: "Stolen" },
                    { key: FAssetConditionDomain.Sold, value: "Sold" },
                    { key: FAssetConditionDomain.UnableToLocate, value: "Unable to locate" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FAssetConditionDomain.GoodWorkingAsRequired] = 0;
                this.KeyIndex[FAssetConditionDomain.FairWorkingInDiminishedCapacity] = 1;
                this.KeyIndex[FAssetConditionDomain.PoorWorkingInSomeCapacityLimitedLifeLeft] = 2;
                this.KeyIndex[FAssetConditionDomain.BrokenDownCanBeRepairedOrWouldWorkIfOtherAssetsWereRepairedOrReplaced] = 3;
                this.KeyIndex[FAssetConditionDomain.NotServiceableCannotBeRepairedNotEconomicalToRepair] = 4;
                this.KeyIndex[FAssetConditionDomain.UsedForSpares] = 5;
                this.KeyIndex[FAssetConditionDomain.DestroyedDumpedDecommissioned] = 6;
                this.KeyIndex[FAssetConditionDomain.Stolen] = 7;
                this.KeyIndex[FAssetConditionDomain.Sold] = 8;
                this.KeyIndex[FAssetConditionDomain.UnableToLocate] = 9;
                this.ValueIndex = {};
                this.ValueIndex["Good - Working as required"] = 0;
                this.ValueIndex["Fair - Working in diminished capacity"] = 1;
                this.ValueIndex["Poor - Working in some capacity - limited life left"] = 2;
                this.ValueIndex["Broken Down - Can be repaired or would work if other assets were repaired or replaced"] = 3;
                this.ValueIndex["Not Serviceable - Cannot be repaired / not economical to repair"] = 4;
                this.ValueIndex["Used for spares"] = 5;
                this.ValueIndex["Destroyed / dumped / decommissioned"] = 6;
                this.ValueIndex["Stolen"] = 7;
                this.ValueIndex["Sold"] = 8;
                this.ValueIndex["Unable to locate"] = 9;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FAssetConditionDomain = FAssetConditionDomain;
    Object.defineProperty(FAssetConditionDomain, "GoodWorkingAsRequired", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FAssetConditionDomain, "FairWorkingInDiminishedCapacity", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FAssetConditionDomain, "PoorWorkingInSomeCapacityLimitedLifeLeft", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(FAssetConditionDomain, "BrokenDownCanBeRepairedOrWouldWorkIfOtherAssetsWereRepairedOrReplaced", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(FAssetConditionDomain, "NotServiceableCannotBeRepairedNotEconomicalToRepair", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(FAssetConditionDomain, "UsedForSpares", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(FAssetConditionDomain, "DestroyedDumpedDecommissioned", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(FAssetConditionDomain, "Stolen", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(FAssetConditionDomain, "Sold", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(FAssetConditionDomain, "UnableToLocate", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 9
    });
    Object.defineProperty(FAssetConditionDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
